import React from 'react';

export default function ContentTabs({ activeTab, onTabChange }) {
  const tabs = [
    { key: 'content', label: 'Content', icon: 'bi-bookmark' },
    { key: 'social', label: 'Social Posts', icon: 'bi-megaphone' },
    { key: 'email', label: 'Email Copy', icon: 'bi-envelope' },
  ];

  return (
    <div className="header-tabs">
      {tabs.map((tab) => (
        <button
          key={tab.key}
          className={`tab ${activeTab === tab.key ? 'tab-active' : ''} tab-${tab.key}`}
          onClick={() => onTabChange(tab.key)}
        >
          <i className={`bi ${tab.icon}`}></i> {tab.label}
        </button>
      ))}
    </div>
  );
}